/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
import { useCallback, useEffect, useRef, useState } from 'react'

import { CONFIG_ENABLE_EDD_ON_CART, IS_PROD_BUILD } from '@src/config/env'
import { EXPERIMENTS, getAssignedExperimentBucket } from '@src/experiments'
import { resetCheckoutPopup } from '@src/quince-components/src/atoms/CheckoutPopup/checkoutPopup.helpers'
import { getIsGoldBarProduct } from '@src/quince-components/src/atoms/productCTA/utils'
import { EMPTY_OBJECT, QUINCE } from '@src/quince-site-common/src/constants/app'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { InventoryInfoSourceType, ShopifyVariantDetails } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ISwatch } from '@src/quince-site-common/src/domains/Swatch'
import {
  FREE_GIFT,
  FREE_TOTE_HANDLE,
  FREE_TOTE_PRODUCT,
  FREE_TOTE_SHOPIFY_ID,
  FREE_TOTE_VARIANT_ID,
  MINIMUM_CART_VALUE,
} from '@src/quince-site-common/src/hooks/cart/constants/freeGiftConstants'
import {
  CartLineItem,
  GiftingDetails,
  LineItems,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'
import {
  saveItemForLater,
  moveItemBackToCart,
} from '@src/quince-site-common/src/services/cartService/saveForLater/saveForLater.service'
import { useCheckout } from '@src/quince-site-common/src/services/checkoutService/hooks/useCheckout'
import NewCheckoutService from '@src/quince-site-common/src/services/checkoutService/NewCheckoutService'
import {
  getCheckoutId,
  getCheckoutUrlFromBuyNowRes,
} from '@src/quince-site-common/src/services/checkoutService/newCheckoutService.helper'
import ShopifyProductService from '@src/quince-site-common/src/services/checkoutService/ShopifyProductService'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'
import productService from '@src/quince-site-common/src/services/productService'
import { handleBuyNowTracking } from '@src/quince-site-common/src/trackers/helpers/handleBuyNowTracking'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'
import {
  clearFindingMethodForVariant,
  getCurrentFindingMethod,
  setFindingMethodForVariant,
} from '@src/telemetry/findingMethod'
import { getProductPropertiesForTracking } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { intersection, keyBy } from '@src/utils/functions/utils'

import { FEATURES, MODULES } from '../../../constants/template-info'
import Product from '../../../domains/Product/Product'
import { BaseProductVariant, ProductVariantOption } from '../../../domains/ProductVariant'
import QuinceApiError from '../../../domains/quince-api-error'
import { CUSTOM_ATTRIBUTE_KEYS, CustomAttribute } from '../../../domains/shopify/CustomAttribute'
import IShopifyCheckout, { IShopifyCheckoutLineItem } from '../../../domains/shopify/ShopifyCheckout'
import { ShopifyEdgeNode } from '../../../domains/shopify/ShopifyEdgeNodeWrapper'
import productHelper from '../../../helpers/productHelper'
import { LineItemDetails, getCartConfig } from '../../../organisms/appLayout/molecules/cartPopUp/cart.helper'
import ordersAndReturnService from '../../../services/ordersAndReturnService'
import AuthUtil from '../../../utils/authUtil'
import { decodeShopifyIdFromGraphqlIdResponse } from '../../../utils/decodeShopifyIdFromGraphqlIdResponse'
import { getIsFinalSaleProduct } from '../../../utils/festivalOffersUtility'
import useDeviceInfo, { DEVICE_TYPES } from '../../useDeviceInfo'
import useFetch from '../../useFetch'
import { isInNewCartExperiment } from '../hooks/new-cart-exp-helper'
import {
  getIdFromEdge,
  getLineItem,
  getLineItemFromEdge,
  getLineItemsSubtotalPriceAmount,
  getpayloadForRemoveLineItems,
  getProductID,
  getProductImageFromLineItem,
  getProductTitleFromNode,
  getQuantityFromEdge,
  getSelectedOptionsFromLineItem,
  getShopifyProductId,
  getShopifyVariantIdFromEdge,
  getSwatchesIdFromLineItem,
  getVariantIdFromEdge,
  getVariantPrice,
  getVariantProductIdFromEdge,
  getVariantTitleFromNode,
  getVarientId,
  isEqualId,
  getSaveForLaterItems,
  getOutOfStockItems,
} from '../hooks/new-cart-helper'
import useInNewCart from '../hooks/use-in-new-cart'
import { TBuyNowCartVariant, TTrackingLineItem } from '../types'

import { GiftProductCardStates, GiftProductEligibilityDetails, ShopifyIdProductMap } from './giftProduct.types'
import { isLineItemExist } from './isLineItemExist'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { removeAllOutOfStockItemsFromCart } from '@src/quince-site-common/src/services/cartService/cart.service'
import { LOCAL_STORAGE_CART_OBJ_KEY } from '@src/quince-site-common/src/services/checkoutService/offshopify.constants'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

const ENV_BASED_ERROR_MESSAGE = IS_PROD_BUILD ? 'Out of Stock' : 'Sales channel not set in Shopify'

const getAllShopifyVariantIdsOfCheckout = (shopifyCheckout: IShopifyCheckout) => {
  const allShopifyVariantIds = (getLineItem(shopifyCheckout) ?? []).map((edge: any) =>
    Number(decodeShopifyIdFromGraphqlIdResponse(getVariantIdFromEdge(edge))),
  )
  return allShopifyVariantIds.filter(Boolean)
}

const useCartContextHelper = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const deviceInfo = useDeviceInfo()
  const inNewCart = useInNewCart()
  const isLoggedIn = AuthUtil.isLoggedIn()

  const [isActionInProgress, setIsActionInProgress] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [isInitializing, setIsInitializing] = useState(true)
  const [isCartPopUpOpen, setIsCartPopUpOpen] = useState(false)
  const [isBuyNowInProgress, setIsBuyNowInProgress] = useState(false)
  const [cartTotalItemsCount, setCartTotalItemsCount] = useState(0)
  const [swatchData, setSwatchData] = useState<null | object>(null)
  const [swatchVariantDetailMap, setSwatchVariantDetailsMap] = useState<Record<string, ShopifyVariantDetails>>({})
  const [isGoldBarInCart, setIsGoldBarInCart] = useState(false)
  const [shopifyCheckout, setShopifyCheckout] = useState<IShopifyCheckout>()
  const giftCardShopifyIdToSeenState = useRef<GiftProductCardStates>({})
  const giftCardShopifyIdToDeleteState = useRef<GiftProductCardStates>({})
  const giftCardShopifyIdToIsPresentInCard = useRef<GiftProductCardStates>({})
  const { checkoutInstance: checkoutService, initialized } = useCheckout()
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.EDD)
  const isEddExperimentEnabled =
    STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.groupA === experimentBucket &&
    CONFIG_ENABLE_EDD_ON_CART

  const onSwatchLinkClick = useCallback(
    async (swatchData: ISwatch[]) => {
      try {
        const getVariantDetailsPromises = swatchData.map(
          async item =>
            await ShopifyProductService.getShopifyVariantDetailsByIdForProductVariants(item as unknown as Product),
        )
        const swatchVariantToVariantDetail = await Promise.all(getVariantDetailsPromises)
        setIsCartPopUpOpen(true)
        setSwatchData(swatchData)
        setSwatchVariantDetailsMap(swatchVariantToVariantDetail || [])
      } catch (e) {
        captureException(e, {
          module: MODULES.CART,
          feature: FEATURES.CLICK_SWATCH_LINK,
          extraInfo: {
            capturedFrom: 'swatch text click on PDP',
          },
        })
      }
    },
    [deviceInfo],
  )
  const removeSwatches = useCallback(
    async (shopifyVariantIds: number[]) => {
      try {
        const lineItems = getLineItem(await checkoutService.getCheckout())
        const removedLineItems = lineItems.filter(lineItem => {
          const id = getSwatchesIdFromLineItem(lineItem)
          return shopifyVariantIds.some(item => item == id)
        })
        const removedLineItemsIds = removedLineItems.map(lineItem => getpayloadForRemoveLineItems(lineItem))
        const shopifyCheckout = await checkoutService.removeLineItems(removedLineItemsIds, 1)
        const { lineItemDetails = {} } = getLineItem(shopifyCheckout)
          ? await getCartConfig(getLineItem(shopifyCheckout))
          : {}
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setShopifyCheckout(shopifyCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        setIsCartPopUpOpen(false)
        setSwatchData(null)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on swatch removeSwatch',
          apiName: 'Swatch remove from cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REMOVE_ITEM,
          extraInfo: {
            capturedFrom: 'swatch remove in useCart',
          },
        })
      }
    },
    [inNewCart, checkoutService],
  )
  const addSwatchesToCart = useCallback(
    async (shopifyVariantIds: number[]) => {
      const swatchesAdded = shopifyVariantIds.map(shopifyVariantId => ({
        shopifyVariantId,
        id: shopifyVariantId,
        quantity: 1,
        customAttributes: [
          new CustomAttribute({
            key: '_FREE_SWATCH_',
            value: true,
          }),
        ],
      }))
      try {
        const shopifyCheckout = await checkoutService.addMultipleToCart(swatchesAdded)
        const { lineItemDetails = {} } = getLineItem(shopifyCheckout)
          ? await getCartConfig(getLineItem(shopifyCheckout))
          : {}
        let productsWithError = false
        swatchesAdded.forEach(({ shopifyVariantId, quantity: _quantity }) => {
          if (!isLineItemExist(shopifyCheckout, { id: +shopifyVariantId, shopifyVariantId })) {
            productsWithError = true
          }
        })
        if (productsWithError) {
          setErrorMessage(`Failed to add all swatches`)
        } else {
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setShopifyCheckout(shopifyCheckout)
          setLineItemDetailsByVariantId(lineItemDetails)
          setIsCartPopUpOpen(false)
          setSwatchData(null)
        }
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on swatch addToCart',
          apiName: 'Swatch Add to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.ADD_TO_CART,
          extraInfo: {
            capturedFrom: 'swatch addToCart in useCart',
          },
        })
      }
    },
    [checkoutService],
  )

  const { fetchData: getIsLoggedInUserEligbleForGoldBar, response: isLoggedInUserEligbleForGoldBarResponse } = useFetch(
    () => ordersAndReturnService.checkIfUserEligibleToBuyGoldBar(),
    {},
  )

  const isLoggedInUserEligbleForGoldBar =
    isLoggedInUserEligbleForGoldBarResponse === undefined ? true : isLoggedInUserEligbleForGoldBarResponse

  const [lineItemDetailsByVariantId, setLineItemDetailsByVariantId] = useState<Record<string, LineItemDetails>>({})
  const [giftProductEligibilityDetails, setGiftProductEligibilityDetails] = useState<GiftProductEligibilityDetails[]>(
    [],
  )
  const [giftCardShopifyIdToProductMap, setGiftCardShopifyIdToProductMap] = useState<ShopifyIdProductMap>({})

  const updateGiftCardShopifyIdToIsPresentInCard = useCallback((shopifyId: number, updatedState: boolean) => {
    giftCardShopifyIdToIsPresentInCard.current = {
      ...giftCardShopifyIdToIsPresentInCard.current,
      [shopifyId]: updatedState,
    }
  }, [])

  const updateGiftCardShopifyIdToSeen = useCallback((shopifyId: number, updatedState = true) => {
    giftCardShopifyIdToSeenState.current = {
      ...giftCardShopifyIdToSeenState.current,
      [shopifyId]: updatedState,
    }
  }, [])

  const updateGiftCardShopifyIdToDelete = useCallback((shopifyId: number, updatedState = true) => {
    giftCardShopifyIdToDeleteState.current = {
      ...giftCardShopifyIdToDeleteState.current,
      [shopifyId]: updatedState,
    }
  }, [])

  const updateFreeGiftCardSeenStatus = useCallback(
    (shopifyVariantId: number, giftShopifyIdToEligibleVariantIds: Record<number, number[]>) => {
      giftProductEligibilityDetails.forEach(({ giftShopifyId }) => {
        if (giftShopifyIdToEligibleVariantIds[giftShopifyId]?.includes(shopifyVariantId)) {
          updateGiftCardShopifyIdToSeen(giftShopifyId)
        }
      })
    },
    [giftProductEligibilityDetails, updateGiftCardShopifyIdToSeen],
  )

  const checkShopifyCheckoutAndUpdateGiftProduct: (
    shopifyCheckout: IShopifyCheckout,
    giftShopifyIdToEligibleVariantIds: Record<number, number[]>,
  ) => void = useCallback(
    (shopifyCheckout: IShopifyCheckout, giftShopifyIdToEligibleVariantIds: Record<number, number[]>) => {
      const allShopifyVariantIds = getAllShopifyVariantIdsOfCheckout(shopifyCheckout)
      const totalAmount = Number(getLineItemsSubtotalPriceAmount(shopifyCheckout))
      Promise.all(
        giftProductEligibilityDetails.map(async cardDetail => {
          const { giftShopifyId, giftShopifyVariantId } = cardDetail
          const isPresentInCart = allShopifyVariantIds.includes(giftShopifyVariantId)
          const isDeletedAfterAdd = giftCardShopifyIdToDeleteState.current[giftShopifyId]
          const isEligibleToAdd =
            intersection(allShopifyVariantIds, giftShopifyIdToEligibleVariantIds[giftShopifyId]).length > 0
          if (isPresentInCart && totalAmount < MINIMUM_CART_VALUE) {
            const shopifyEdge = (getLineItem(shopifyCheckout) || []).find(
              (edge: any) =>
                decodeShopifyIdFromGraphqlIdResponse(getVariantProductIdFromEdge(edge)) === giftShopifyId.toString(),
            )
            updateGiftCardShopifyIdToIsPresentInCard(giftShopifyId, false)
            if (shopifyEdge) {
              const id = getIdFromEdge(shopifyEdge)
              if (id !== undefined) {
                removeLineItem(id).catch((err: unknown) => {
                  console.error(err)
                })
              }
            }
          } else if (
            !isPresentInCart &&
            !isDeletedAfterAdd &&
            (isEligibleToAdd || giftCardShopifyIdToSeenState.current[giftShopifyId]) &&
            totalAmount >= MINIMUM_CART_VALUE
          ) {
            const product = giftCardShopifyIdToProductMap[giftShopifyId]
            const availableQuantity = product
              ? await ShopifyProductService.getAvailableInventoryForSelectedOption(
                  product,
                  product?.variants[0]?.options || [],
                  FREE_TOTE_HANDLE,
                )
              : 0
            if (availableQuantity > 0) {
              updateGiftCardShopifyIdToIsPresentInCard(giftShopifyId, true)
              if (product) {
                addToCart(product, product?.variants[0]?.options || [], 1, [
                  {
                    key: FREE_GIFT,
                    value: 'true',
                  },
                ]).catch((err: unknown) => {
                  console.error(err)
                })
              }
            }
          }
        }),
      ).catch((err: unknown) => {
        console.error(err)
      })
    },
    [giftCardShopifyIdToProductMap, giftProductEligibilityDetails, updateGiftCardShopifyIdToIsPresentInCard],
  )

  const buyNowCart = async (variantInfos: TBuyNowCartVariant[]) => {
    setIsBuyNowInProgress(true)
    setErrorMessage('')
    try {
      resetCheckoutPopup()
      const buyNowCartObject: LineItems = []
      variantInfos.forEach(({ product, selectedOptions, quantity, customAttributes }) => {
        const variants = productHelper.getVariantsForOptions(product, selectedOptions)
        if (variants.length == 1) {
          const selectedVariant = variants[0]
          buyNowCartObject.push({
            variantId: getVarientId(selectedVariant),
            quantity: quantity ?? 1,
            attributes: getCustomAttributesForSelectedOptionsForAddToCart(product, selectedOptions, customAttributes),
          })
        }
      })
      const { response, lineItems } = await (checkoutService as NewCheckoutService).buyNowCart(buyNowCartObject)
      handleBuyNowTracking(
        variantInfos,
        lineItems.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
      )
      const checkoutUrl = getCheckoutUrlFromBuyNowRes(response)
      if (checkoutUrl && isBrowser()) window.location.href = checkoutUrl
      if (!checkoutUrl) throw new Error('Failed to get checkout url from buy now response')
    } catch (error) {
      const quinceError = new QuinceApiError({
        error: error as Error,
        message: 'Failed on buyNow',
        apiName: 'Buy now cart',
      })
      captureException(quinceError, {
        module: MODULES.CART,
        feature: FEATURES.BUY_NOW_CART,
        extraInfo: {
          capturedFrom: 'buyNowCart in useCart',
        },
      })
      setErrorMessage('Failed to buy now. Please try again in some time.')
    } finally {
      setIsBuyNowInProgress(false)
    }
  }

  const addToCart = useCallback(
    async (
      product: Product,
      selectedOptions: ProductVariantOption[],
      quantity = 1,
      customAttributes: CustomAttribute[] = [],
      trackerSection: string | undefined = undefined,
      isPreorder?: boolean,
      productSearchQuery?: string,
      productPosition?: number,
      inventoryInfoSource?: InventoryInfoSourceType,
      eddDetail?: EDDDetails,
    ) => {
      setIsActionInProgress(true)
      setErrorMessage('')
      const variants = productHelper.getVariantsForOptions(product, selectedOptions)
      try {
        if (variants.length == 1) {
          const selectedVariant = variants[0]
          resetCheckoutPopup()
          const shopifyCheckout = await checkoutService.addToCart(
            getVarientId(selectedVariant),
            quantity,
            getCustomAttributesForSelectedOptionsForAddToCart(product, selectedOptions, customAttributes),
          )

          if (selectedVariant && isLineItemExist(shopifyCheckout, selectedVariant)) {
            const { lineItemDetails = {}, giftShopifyIdToEligibleVariantIds = {} } = getLineItem(shopifyCheckout)
              ? await getCartConfig(getLineItem(shopifyCheckout))
              : {}

            const productColor = selectedOptions.filter(t => t.name === ProductOptionName.Color)[0]?.value
            updateFreeGiftCardSeenStatus(getVarientId(selectedVariant), giftShopifyIdToEligibleVariantIds)

            checkShopifyCheckoutAndUpdateGiftProduct(shopifyCheckout, giftShopifyIdToEligibleVariantIds)

            const lineItemShopifyVariant = getLineItem(shopifyCheckout)?.filter((item: any) => {
              return isEqualId(getVariantIdFromEdge(item)?.toString() || '', getVarientId(selectedVariant)?.toString())
            })

            const lineItemFromEdge = lineItemShopifyVariant?.[0]
              ? getLineItemFromEdge(lineItemShopifyVariant?.[0])
              : undefined

            const currentFindingMethod = getCurrentFindingMethod()
            setFindingMethodForVariant(selectedVariant?.shopifyVariantId?.toString())
            trackEvent(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
              variantId: selectedVariant?.shopifyVariantId,
              productId: product.shopifyProductId,
              internalProductId: `${product.id}_${productColor}`,
              lineItems: getLineItem(shopifyCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
              productType: product.productTypeName,
              size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
              price: selectedVariant?.price,
              vendor: QUINCE,
              productTitle: product.title,
              variantTitle: selectedVariant?.title,
              sku: selectedVariant?.sku,
              quantity: quantity,
              trackerSection: trackerSection,
              variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
              isPreorder,
              productSearchQuery,
              productPosition,
              inventoryInfoSource,
              division: product.classification?.division?.name,
              department: product.classification?.department?.name,
              subDepartment: product.classification?.subDepartment?.name,
              class: product?.classification?.class?.name,
              subClass: product?.classification?.subClass?.name,
              color_variant: product.new_color_options && (product.new_color_options || []).map(item => item.value),
              gender: product.gender,
              productProperties: getProductPropertiesForTracking(
                product,
                selectedVariant?.shopifyVariantId?.toString(),
              ),
              slug: lineItemFromEdge?.slug,
              internal_variant_id: selectedVariant?.id,
              internal_product_id: product?.id,
              context: {
                findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
                findingMethodGranular: currentFindingMethod?.findingMethodGranular,
                findingMethodId: currentFindingMethod?.findingMethodId,
                edd_standard_eligible: eddDetail?.type === 'LB_STANDARD',
                edd_express_eligible: eddDetail?.type === 'LB_SUPER',
                edd_max_days: eddDetail?.max_days,
                edd_min_days: eddDetail?.min_days,
              },
            })
            // After Adding to Cart opening popup by default. Not opening for cart landing page

            const isNotCartPath = window.location.pathname !== '/cart'
            const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
            if (isNotCartPath || isMobile) {
              setIsCartPopUpOpen(true)
            }
            setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
            setShopifyCheckout(shopifyCheckout)
            setLineItemDetailsByVariantId(lineItemDetails)
            void refreshFulfillmentDetails()
          } else {
            setErrorMessage(ENV_BASED_ERROR_MESSAGE)
          }
        }
      } catch (error) {
        const selectedVariant = variants[0]
        const productColor = selectedOptions.filter(t => t.name === ProductOptionName.Color)[0]?.value

        const lineItemShopifyVariant = (shopifyCheckout ? (getLineItem(shopifyCheckout) ?? []) : [])?.filter(item => {
          return isEqualId(getVariantIdFromEdge(item)?.toString() ?? '', getVarientId(selectedVariant)?.toString())
        })
        const lineItemFromEdge = lineItemShopifyVariant?.[0]
          ? getLineItemFromEdge(lineItemShopifyVariant?.[0])
          : undefined

        const currentFindingMethod = getCurrentFindingMethod()
        if (selectedVariant?.shopifyVariantId.toString()) {
          setFindingMethodForVariant(selectedVariant?.shopifyVariantId.toString())
        }

        trackEvent(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
          variantId: selectedVariant?.shopifyVariantId,
          productId: product.shopifyProductId.toString(),
          internalProductId: `${product.id}_${productColor}`,
          productType: product.productTypeName,
          price: selectedVariant?.price,
          size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
          vendor: QUINCE,
          productTitle: product.title,
          variantTitle: selectedVariant?.title,
          sku: selectedVariant?.sku,
          quantity: quantity,
          trackerSection: trackerSection,
          isPreorder,
          productSearchQuery,
          productPosition,
          inventoryInfoSource,
          division: product?.classification?.division?.name,
          department: product?.classification?.department?.name,
          subDepartment: product?.classification?.subDepartment?.name,
          class: product?.classification?.class?.name,
          subClass: product?.classification?.subClass?.name,
          internal_variant_id: selectedVariant?.id,
          internal_product_id: product?.id,
          variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
          productProperties: getProductPropertiesForTracking(product, selectedVariant?.shopifyVariantId?.toString()),
          slug: lineItemFromEdge?.slug,
          context: {
            findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
            findingMethodGranular: currentFindingMethod?.findingMethodGranular,
            findingMethodId: currentFindingMethod?.findingMethodId,
            edd_standard_eligible: eddDetail?.type === 'LB_STANDARD',
            edd_express_eligible: eddDetail?.type === 'LB_SUPER',
            edd_max_days: eddDetail?.max_days,
            edd_min_days: eddDetail?.min_days,
          },
        })
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on addToCart',
          apiName: 'Add to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.ADD_TO_CART,
          extraInfo: {
            capturedFrom: 'addToCart in useCart',
          },
        })

        setErrorMessage('Failed to add item to cart. Please try again in some time.')
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkShopifyCheckoutAndUpdateGiftProduct, deviceInfo.deviceType, inNewCart, updateFreeGiftCardSeenStatus],
  )

  const addMultipleToCart = useCallback(
    async (
      productConfigs: {
        product: Product
        selectedOptions: ProductVariantOption[]
        quantity?: number
        customAttributes: CustomAttribute[]
      }[],
      trackerSection: string | undefined = undefined,
    ) => {
      setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const selectedVariantsForProduct: BaseProductVariant[] = []

        const addToCartRequest: {
          shopifyVariantId: number
          quantity: number
          customAttributes: CustomAttribute[]
        }[] = []

        productConfigs.forEach(({ product, selectedOptions, quantity, customAttributes }) => {
          const variants = productHelper.getVariantsForOptions(product, selectedOptions)
          if (variants.length == 1) {
            const selectedVariant = variants[0]
            if (selectedVariant) {
              selectedVariantsForProduct.push(selectedVariant)
            }
            addToCartRequest.push({
              shopifyVariantId: getVarientId(selectedVariant),
              quantity: quantity || 0,
              customAttributes: getCustomAttributesForSelectedOptionsForAddToCart(
                product,
                selectedOptions || [],
                customAttributes || [],
              ),
            })
          }
        })
        const shopifyCheckout = await checkoutService.addMultipleToCart(addToCartRequest)

        const productsWithError: string[] = []
        productConfigs.forEach(({ product, quantity: _quantity }, index) => {
          const selectedVariant = selectedVariantsForProduct[index]
          const quantity = _quantity || 1
          const productColor = selectedVariant?.options.filter(t => t.name === ProductOptionName.Color)[0]?.value

          if (selectedVariant && isLineItemExist(shopifyCheckout, selectedVariant)) {
            const lineItemShopifyVariant = getLineItem(shopifyCheckout)?.filter(item => {
              return isEqualId(getVariantIdFromEdge(item)?.toString() || '', getVarientId(selectedVariant)?.toString())
            })
            const lineItemFromEdge = lineItemShopifyVariant?.[0]
              ? getLineItemFromEdge(lineItemShopifyVariant?.[0])
              : undefined

            const currentFindingMethod = getCurrentFindingMethod()
            setFindingMethodForVariant(selectedVariant?.shopifyVariantId?.toString())

            trackEvent(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
              variantId: selectedVariant?.shopifyVariantId,
              productId: selectedVariant?.shopifyProductId.toString(),
              internalProductId: `${product.id}_${productColor}`,
              lineItems: getLineItem(shopifyCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
              productType: product.productTypeName,
              price: selectedVariant?.price,
              size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
              vendor: 'Quince',
              productTitle: product.title,
              variantTitle: selectedVariant?.title,
              sku: selectedVariant?.sku,
              quantity: quantity,
              trackerSection: trackerSection,
              variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
              productProperties: getProductPropertiesForTracking(
                product,
                selectedVariant?.shopifyVariantId?.toString(),
              ),
              division: product?.classification?.division?.name,
              department: product?.classification?.department?.name,
              subDepartment: product?.classification?.subDepartment?.name,
              class: product?.classification?.class?.name,
              subClass: product?.classification?.subClass?.name,
              internal_variant_id: selectedVariant?.id,
              internal_product_id: product?.id,
              slug: lineItemFromEdge?.slug,
              context: {
                findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
                findingMethodGranular: currentFindingMethod?.findingMethodGranular,
                findingMethodId: currentFindingMethod?.findingMethodId,
              },
            })
          } else {
            productsWithError.push(product.title)
          }
        })
        if (productsWithError.length) {
          const productNamesWithError = productsWithError.join(', ')
          setErrorMessage(`${productNamesWithError} ${ENV_BASED_ERROR_MESSAGE}`)
        } else {
          // After Adding to Cart opening popup by default. Not opening for cart landing page
          const isNotCartPath = window.location.pathname !== '/cart'
          const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
          if (isNotCartPath || isMobile) {
            setIsCartPopUpOpen(true)
          }
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          const { lineItemDetails = {}, giftShopifyIdToEligibleVariantIds = {} } = shopifyCheckout?.lineItems?.edges
            ? await getCartConfig(shopifyCheckout.lineItems.edges)
            : {}
          productConfigs.forEach((_, index) => {
            const selectedVariant = selectedVariantsForProduct[index]
            updateFreeGiftCardSeenStatus(getVarientId(selectedVariant), giftShopifyIdToEligibleVariantIds)
          })

          checkShopifyCheckoutAndUpdateGiftProduct(shopifyCheckout, giftShopifyIdToEligibleVariantIds)

          setShopifyCheckout(shopifyCheckout)
          setLineItemDetailsByVariantId(lineItemDetails)
          void refreshFulfillmentDetails()
        }
      } catch (error) {
        captureException(error, {
          module: MODULES.CART,
          feature: FEATURES.ADD_MULTI_ITEM_TO_CART,
          extraInfo: {
            capturedFrom: 'Failed on addToCartt',
          },
        })
        setErrorMessage('Failed to add items to cart. Please try again in some time.')
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkShopifyCheckoutAndUpdateGiftProduct, deviceInfo.deviceType, updateFreeGiftCardSeenStatus],
  )

  const updateLineItem = useCallback(
    async (lineItemId: string, quantity: number, adjustment: number | '' | null = '') => {
      setIsActionInProgress(true)
      setErrorMessage('')
      try {
        const lineItem = getLineItem(await checkoutService.getCheckout())?.find(
          (lineItem: any) => lineItemId === getIdFromEdge(lineItem),
        )

        const shopifyCheckout = await checkoutService.updateLineItem(lineItemId, quantity, adjustment)
        const updatedLineItems =
          quantity === 0
            ? [...(getLineItem(shopifyCheckout) as ShopifyEdgeNode<IShopifyCheckoutLineItem>[]), lineItem]
            : getLineItem(shopifyCheckout)

        const { lineItemDetails = {}, giftShopifyIdToEligibleVariantIds = {} } = getLineItem(shopifyCheckout)
          ? await getCartConfig(updatedLineItems as ShopifyEdgeNode<IShopifyCheckoutLineItem>[])
          : {}

        checkShopifyCheckoutAndUpdateGiftProduct(shopifyCheckout, giftShopifyIdToEligibleVariantIds)
        const itemId = getVariantIdFromEdge(lineItem as CartLineItem)
        const activeLineItem = lineItemDetails?.[itemId]
        if (quantity === 0) {
          delete lineItemDetails?.[itemId]
        }
        const { color, internalProductId }: { color?: string; internalProductId?: string | number } =
          activeLineItem || EMPTY_OBJECT

        const variantId = decodeShopifyIdFromGraphqlIdResponse(getShopifyVariantIdFromEdge(lineItem))
        if (quantity === 0 && variantId) {
          clearFindingMethodForVariant(variantId)
        }
        trackEvent(TELEMETRY_EVENT_NAMES.UPDATE_ITEM_QUANTITY, {
          variantId: decodeShopifyIdFromGraphqlIdResponse(getShopifyVariantIdFromEdge(lineItem)),
          productId: getShopifyProductId(lineItem),
          lineItems: getLineItem(shopifyCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
          internalProductId: `${internalProductId}_${color}`,
          size: getSelectedOptionsFromLineItem(lineItem)?.filter((t: { name: string }) => t.name === 'Size')?.[0]
            ?.value,
          price: getVariantPrice(lineItem),
          atcClickAction:
            quantity < getQuantityFromEdge(lineItem as unknown as CartLineItem)
              ? 'QUANTITY_DECREASE'
              : 'QUANTITY_INCREASE',
        })
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setShopifyCheckout(shopifyCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on update cart item',
          apiName: 'update cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.UPDATE_LINE_ITEM,
          extraInfo: {
            capturedFrom: 'updateLineItem in useCart',
          },
        })
        setErrorMessage('Failed to update cart. Please try again in some time.')
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkShopifyCheckoutAndUpdateGiftProduct, inNewCart],
  )

  const removeLineItem = useCallback(
    async (lineItemId: string, isSavedForLater?: boolean, isOutOfStock?: boolean) => {
      setIsActionInProgress(true)
      setErrorMessage('')
      try {
        let lineItem: CartLineItem | undefined = undefined
        if (isSavedForLater) {
          lineItem = getSaveForLaterItems(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        } else if (isOutOfStock) {
          lineItem = getOutOfStockItems(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        } else {
          lineItem = getLineItem(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        }

        const shopifyCheckout = await checkoutService.removeLineItem(lineItemId, lineItem?.quantity)
        const { lineItemDetails = {}, giftShopifyIdToEligibleVariantIds = {} } = getLineItem(shopifyCheckout)
          ? await getCartConfig([
              ...getLineItem(shopifyCheckout),
              lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>,
            ])
          : {}

        const idToDelete = getVariantIdFromEdge(lineItem) as string
        const lineItemDetailsForDeletedItem = lineItemDetails[idToDelete]
        // Deleting the item as we don't need it
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete lineItemDetails[idToDelete]

        const { color, internalProductId } = lineItemDetailsForDeletedItem || EMPTY_OBJECT
        checkShopifyCheckoutAndUpdateGiftProduct(shopifyCheckout, giftShopifyIdToEligibleVariantIds)

        let product: Product | undefined = undefined

        void productService
          .getProducts({ shopifyProductIds: getProductID(lineItem) ? [getProductID(lineItem)] : [] })
          .then(products => {
            product = products[0]
          })
          .finally(() => {
            const variantId = decodeShopifyIdFromGraphqlIdResponse(getShopifyVariantIdFromEdge(lineItem))?.toString()
            if (variantId) {
              clearFindingMethodForVariant(variantId)
            }
            trackEvent(TELEMETRY_EVENT_NAMES.REMOVE_FROM_CART, {
              variantId: decodeShopifyIdFromGraphqlIdResponse(getShopifyVariantIdFromEdge(lineItem)),
              productId: getProductID(lineItem),
              shopifyProductId: getShopifyProductId(lineItem),
              department: product?.classification?.department?.name ?? '',
              lineItems: getLineItem(shopifyCheckout)?.map(lineItem => extractLineItemFromGraphEdge(lineItem)),
              internalProductId: `${internalProductId}_${color}`,
              price: getVariantPrice(lineItem),
              vendor: 'Quince',
              productTitle: getProductTitleFromNode(lineItem),
              variantTitle: getVariantTitleFromNode(lineItem),
              sku: lineItem?.variantMetaData?.sku,
              quantity: getQuantityFromEdge(lineItem),
              productProperties: product
                ? getProductPropertiesForTracking(
                    product,
                    decodeShopifyIdFromGraphqlIdResponse(getShopifyVariantIdFromEdge(lineItem)),
                  )
                : [],
              variantImageUrl: lineItem?.variantMetaData?.imageUrl,
              slug: lineItem?.slug,
            })
          })

        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())

        setShopifyCheckout(shopifyCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on remove cart item',
          apiName: 'remove LineItem',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REMOVE_ITEM,
          extraInfo: {
            capturedFrom: 'removeLineItem in useCart',
          },
        })

        setErrorMessage('Failed to update cart. Please try again in some time.')
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkShopifyCheckoutAndUpdateGiftProduct, inNewCart],
  )

  const initialiseGiftCardStates = useCallback(
    (giftCardEligibilityResponse: GiftProductEligibilityDetails[], shopifyCheckout: IShopifyCheckout) => {
      const allShopifyVariantIdInCart = getAllShopifyVariantIdsOfCheckout(shopifyCheckout)
      giftCardEligibilityResponse.forEach(({ giftShopifyId, eligibleProductIds, giftShopifyVariantId }) => {
        const isGiftPresentInCart = allShopifyVariantIdInCart.includes(giftShopifyVariantId)
        const isGiftProductSeenByUser = intersection(eligibleProductIds, allShopifyVariantIdInCart).length > 0
        if (isGiftProductSeenByUser || isGiftPresentInCart) {
          updateGiftCardShopifyIdToSeen(giftShopifyId)
        }
        if (isGiftPresentInCart) {
          updateGiftCardShopifyIdToIsPresentInCard(giftShopifyId, true)
        }
        updateGiftCardShopifyIdToDelete(giftShopifyId, false)
      })
    },
    [updateGiftCardShopifyIdToSeen, updateGiftCardShopifyIdToIsPresentInCard, updateGiftCardShopifyIdToDelete],
  )

  const updateGiftingDetails = useCallback(
    async (giftingDetails: GiftingDetails) => {
      setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const updatedCartData = await checkoutService.updateGiftingDetailsForCart(giftingDetails)

        if (updatedCartData) {
          setShopifyCheckout(updatedCartData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          void refreshFulfillmentDetails(true)
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to update gifting details',
          apiName: 'Update Gifting Details',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.E_GIFTING,
          extraInfo: {
            capturedFrom: 'updateGiftingDetails in useCartContextHelper',
          },
        })
        setErrorMessage('Failed to update gifting details. Please try again later.')
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService],
  )

  const updateGiftingFlag = useCallback(
    async (isGift: boolean) => {
      // setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const updatedCartData = await checkoutService.updateGiftingFlag(isGift)
        if (updatedCartData) {
          setShopifyCheckout(updatedCartData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          void refreshFulfillmentDetails(true)
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to update gifting flag',
          apiName: 'Update Gifting Flag',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.E_GIFTING,
          extraInfo: {
            capturedFrom: 'updateGiftingFlag in useCartContextHelper',
          },
        })
        setErrorMessage('Failed to update gifting status. Please try again later.')
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService],
  )

  const getGiftingDetails = useCallback(() => {
    if (shopifyCheckout?.giftingDetails) {
      const giftingDetails = shopifyCheckout.giftingDetails
      return {
        recipientName: giftingDetails?.recipientName || '',
        recipientEmail: giftingDetails?.recipientEmail || '',
        senderName: giftingDetails?.senderName || '',
        giftMessage: giftingDetails?.giftMessage || null,
      }
    }
    return {
      recipientName: '',
      recipientEmail: '',
      senderName: '',
      giftMessage: '',
    }
  }, [shopifyCheckout])

  const getGiftingFlag = useCallback(() => {
    if (shopifyCheckout) {
      return shopifyCheckout.isGift
    }
    return false
  }, [shopifyCheckout])

  const moveToSaveForLater = useCallback(
    async (lineItemData: IShopifyCheckoutLineItem | CartLineItem) => {
      setErrorMessage('')
      try {
        const cartId = getCheckoutId()
        if (cartId) {
          const lineItems = [
            {
              lineItemId: lineItemData.id,
            },
          ]
          const checkoutData = await saveItemForLater(cartId, lineItems)
          const saveForLaterLineItem = getSaveForLaterItems(checkoutData)
          const lineItem = getLineItem(checkoutData)

          const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
          const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
            ? await getCartConfig(saveForLaterLineItem)
            : {}
          const outOfStockLineItem = getOutOfStockItems(checkoutData)
          const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
            ? await getCartConfig(outOfStockLineItem)
            : {}
          setShopifyCheckout(checkoutData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })

          void refreshFulfillmentDetails()
        } else {
          console.error('Cart ID does not exist')
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to move product to save for later',
          apiName: 'Move to Save for later',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.SAVE_FOR_LATER,
          extraInfo: {
            capturedFrom: 'moveToSaveForLater in useCartContextHelper',
          },
        })
        setErrorMessage('Failed to move to Save For Later. Please try again later.')
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService],
  )
  const moveBackToCart = useCallback(
    async (lineItemData: IShopifyCheckoutLineItem | CartLineItem) => {
      setErrorMessage('')
      try {
        const cartId = getCheckoutId()
        if (cartId) {
          const lineItems = [
            {
              lineItemId: lineItemData.id,
            },
          ]
          const checkoutData = await moveItemBackToCart(cartId, lineItems)
          const saveForLaterLineItem = getSaveForLaterItems(checkoutData)
          const lineItem = getLineItem(checkoutData)

          const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
          const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
            ? await getCartConfig(saveForLaterLineItem)
            : {}
          const outOfStockLineItem = getOutOfStockItems(checkoutData)
          const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
            ? await getCartConfig(outOfStockLineItem)
            : {}
          setShopifyCheckout(checkoutData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })

          void refreshFulfillmentDetails()
        } else {
          console.error('Cart ID does not exist')
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to move product to cart from save for later',
          apiName: 'Move back to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.SAVE_FOR_LATER,
          extraInfo: {
            capturedFrom: 'moveBackToCart in useCartContextHelper',
          },
        })
        setErrorMessage('Failed to move back to Cart. Please try again later.')
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService],
  )
  const removeAllOutOfStockItems = useCallback(async () => {
    setErrorMessage('')
    try {
      const cartId = getCheckoutId()
      if (cartId) {
        const checkoutData = await removeAllOutOfStockItemsFromCart(cartId)
        const lineItem = getLineItem(checkoutData)

        const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
        const outOfStockLineItem = getOutOfStockItems(checkoutData)
        const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
          ? await getCartConfig(outOfStockLineItem)
          : {}
        const savedLineItem = getSaveForLaterItems(checkoutData)
        const { lineItemDetails: savedItemDetails = {} } = savedLineItem ? await getCartConfig(savedLineItem) : {}

        setShopifyCheckout(checkoutData)
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setLineItemDetailsByVariantId({ ...lineItemDetails, ...outOfStockItemDetails, ...savedItemDetails })
      } else {
        console.error('Cart ID does not exist')
      }
    } catch (error) {
      const quinceError = new QuinceApiError({
        error: error as Error,
        message: 'Failed to remove all out of stock items',
        apiName: 'Remove all out of stock items',
      })
      captureException(quinceError, {
        module: MODULES.CART,
        feature: FEATURES.REMOVE_OUT_OF_STOCK_ITEMS,
        extraInfo: {
          capturedFrom: 'removeAllOutOfStockItems in useCartContextHelper',
        },
      })
      setErrorMessage('Failed to remove all out of stock items. Please try again later.')
      throw error
    } finally {
      setIsActionInProgress(false)
    }
  }, [checkoutService])

  const refreshFulfillmentDetails = useCallback(
    async (ignoreIfNotExpired?: boolean) => {
      try {
        if (!isEddExperimentEnabled || !shopifyCheckout?.lineItems?.length) {
          return
        }

        const checkoutData = await checkoutService?.refreshFulfillmentDetails(ignoreIfNotExpired)
        if (!checkoutData) {
          console.error('Checkout data is not available')
          return
        }

        const cartData = checkoutData?.cart
        if (!cartData) {
          console.error('Cart data is not available')
          return
        }

        const lineItemsDataWithFulfillmentDetails = cartData?.lineItems
        if (!lineItemsDataWithFulfillmentDetails) {
          console.error('Line items data with fulfillment details is not available')
          return
        }

        const lineItemsDataWithFulfillmentDetailsMap = keyBy(lineItemsDataWithFulfillmentDetails, 'id')

        const currentCheckoutData = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_CART_OBJ_KEY) || '{}')
        const currentLineItemsDataWithFulfillmentDetails = currentCheckoutData?.lineItems?.map(lineItem => ({
          ...lineItem,
          minDeliveryDate: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.minDeliveryDate,
          maxDeliveryDate: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.maxDeliveryDate,
          minDaysToDelivery: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.minDaysToDelivery,
          maxDaysToDelivery: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.maxDaysToDelivery,
        }))

        const updatedCheckoutData = {
          ...currentCheckoutData,
          lineItems: currentLineItemsDataWithFulfillmentDetails,
        }

        const lineItem = getLineItem(updatedCheckoutData)

        const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
        const outOfStockLineItem = getOutOfStockItems(updatedCheckoutData)
        const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
          ? await getCartConfig(outOfStockLineItem)
          : {}
        const savedLineItem = getSaveForLaterItems(updatedCheckoutData)
        const { lineItemDetails: savedItemDetails = {} } = savedLineItem ? await getCartConfig(savedLineItem) : {}

        setShopifyCheckout(updatedCheckoutData)
        setLineItemDetailsByVariantId({ ...lineItemDetails, ...outOfStockItemDetails, ...savedItemDetails })
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to call refreshFulfillmentDetails',
          apiName: 'Refresh Fulfillment Details',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REFRESH_FULFILLMENT_DETAILS,
          extraInfo: {
            capturedFrom: 'refreshFulfillmentDetails in useCartContextHelper',
          },
        })
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, shopifyCheckout],
  )

  const initializeShopifyCheckout = useCallback(async () => {
    if (!initialized || !('getCheckout' in checkoutService)) return
    setIsActionInProgress(true)
    const shopifyCheckout = await checkoutService.getCheckout()
    const freeToteExperimentBucket = getAssignedExperimentBucket(EXPERIMENTS.FREE_TOTE?.experimentName || '')
    const isOldUserAndShowBucket = getlbUserId() && freeToteExperimentBucket === EXPERIMENTS.FREE_TOTE?.bucketNames.show

    const lineItem = getLineItem(shopifyCheckout)
    const saveForLaterLineItem = getSaveForLaterItems(shopifyCheckout)
    const outOfStockLineItem = getOutOfStockItems(shopifyCheckout)
    const { lineItemDetails = {}, giftShopifyIdToEligibleVariantIds = [] } = lineItem
      ? await getCartConfig(lineItem)
      : {}

    const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
      ? await getCartConfig(saveForLaterLineItem)
      : {}
    const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
      ? await getCartConfig(outOfStockLineItem)
      : {}

    //make call only when we have to show the gift else skip
    const availableQuantity =
      isOldUserAndShowBucket && FREE_TOTE_PRODUCT[0]
        ? await ShopifyProductService.getAvailableInventoryForSelectedOption(
            FREE_TOTE_PRODUCT[0],
            FREE_TOTE_PRODUCT[0]?.variants?.[0]?.options || [],
            FREE_TOTE_HANDLE,
          )
        : 0
    const shouldShowFreeTote = isOldUserAndShowBucket && availableQuantity > 0
    const giftCardEligibilityDetailsObject = shouldShowFreeTote
      ? [
          {
            giftShopifyId: FREE_TOTE_SHOPIFY_ID,
            eligibleProductIds: giftShopifyIdToEligibleVariantIds[FREE_TOTE_SHOPIFY_ID],
            giftShopifyVariantId: FREE_TOTE_VARIANT_ID,
          },
        ]
      : []

    const giftCardProducts = shouldShowFreeTote ? FREE_TOTE_PRODUCT : []

    initialiseGiftCardStates(giftCardEligibilityDetailsObject, shopifyCheckout)
    setGiftCardShopifyIdToProductMap(keyBy(giftCardProducts, 'shopifyProductId'))
    setGiftProductEligibilityDetails(giftCardEligibilityDetailsObject)
    setShopifyCheckout(shopifyCheckout)
    setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })
    setIsActionInProgress(false)
    setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
    setIsInitialized(true)
  }, [initialiseGiftCardStates, checkoutService])

  useEffect(() => {
    setIsInitializing(true)
    initializeShopifyCheckout()
      .catch((e: unknown) => {
        captureException(e, {
          module: MODULES.CART,
          feature: FEATURES.INIT_CHECKOUT,
          extraInfo: {
            capturedFrom: 'initializeShopifyCheckout in useCart',
          },
        })
      })
      .finally(() => {
        setIsInitializing(false)
      })
  }, [initializeShopifyCheckout])

  useEffect(() => {
    if (isGoldBarInCart && isLoggedIn) {
      setIsActionInProgress(true)
      getIsLoggedInUserEligbleForGoldBar()
        .catch((e: unknown) => {
          console.error('Failed while fetching getIsLoggedInUserEligbleForGoldBar()', e)
        })
        .finally(() => {
          setIsActionInProgress(false)
        })
    }
  }, [isGoldBarInCart, isLoggedIn])

  return {
    addToCart,
    buyNowCart,
    isBuyNowInProgress,
    addMultipleToCart,
    removeLineItem,
    updateLineItem,
    isGoldBarInCart,
    setIsGoldBarInCart,
    isLoggedInUserEligbleForGoldBar,
    isActionInProgress,
    errorMessage,
    setErrorMessage,
    isCartPopUpOpen,
    cartTotalItemsCount,
    shopifyCheckout,
    lineItemDetailsByVariantId,
    isInitialized,
    isInitializing,
    setIsCartPopUpOpen,
    giftProductEligibilityDetails,
    giftCardShopifyIdToSeenState: giftCardShopifyIdToSeenState.current,
    giftCardShopifyIdToDeleteState: giftCardShopifyIdToDeleteState.current,
    giftCardShopifyIdToIsPresentInCard: giftCardShopifyIdToIsPresentInCard.current,
    updateGiftCardShopifyIdToDelete,
    giftCardShopifyIdToProductMap,
    refreshShopifyCheckout: initializeShopifyCheckout,
    onSwatchLinkClick,
    swatchData,
    addSwatchesToCart,
    removeSwatches,
    setSwatchData,
    swatchVariantDetailMap,
    updateGiftingDetails,
    getGiftingDetails,
    updateGiftingFlag,
    getGiftingFlag,
    moveToSaveForLater,
    moveBackToCart,
    removeAllOutOfStockItems,
  }
}

export const extractLineItemFromGraphEdge = (
  lineItemEdge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem,
): TTrackingLineItem => {
  const isInNewCart = isInNewCartExperiment()
  if (isInNewCart) {
    const { id, variantMetaData, quantity, productMetaData } = lineItemEdge as CartLineItem
    return {
      id: id,
      sku: variantMetaData?.sku,
      price: variantMetaData?.price,
      title: variantMetaData?.productTitle,
      quantity: quantity,
      productId: productMetaData?.shopifyProductId,
      variantId: productMetaData?.shopifyVariantId,
      variantTitle: variantMetaData?.variantTitle,
    }
  }

  const { id, variant, title, quantity } = (lineItemEdge as ShopifyEdgeNode<IShopifyCheckoutLineItem>).node || {}
  return {
    id: id,
    sku: variant?.sku,
    price: variant?.priceV2?.amount,
    title: title,
    quantity: quantity,
    productId: decodeShopifyIdFromGraphqlIdResponse(variant?.product?.id),
    variantId: decodeShopifyIdFromGraphqlIdResponse(variant?.id),
    variantTitle: variant?.title,
  }
}

const getCustomAttributesForSelectedOptionsForAddToCart = (
  product: Product,
  selectedOptions: ProductVariantOption[],
  customAttributes: CustomAttribute[],
): CustomAttribute[] => {
  // Adding custom attributes in case we have customization
  const isFinalSaleProduct = getIsFinalSaleProduct(product, selectedOptions)
  const isGoldBarProduct = getIsGoldBarProduct(product)

  const updatedCustomAttributes = [...customAttributes]
  if (isFinalSaleProduct) {
    updatedCustomAttributes.push({
      key: '_' + CUSTOM_ATTRIBUTE_KEYS.FINAL_SALE, // Need to add underscore to hide attributes on checkout page
      value: 'true',
    })
  }
  if (isGoldBarProduct) {
    updatedCustomAttributes.push({
      key: '_' + CUSTOM_ATTRIBUTE_KEYS.GOLD_BAR_PRODUCT,
      value: 'true',
    })
  }

  selectedOptions.forEach(selectedOption => {
    if (selectedOption.name === ProductOptionName.Customization) {
      updatedCustomAttributes.push({
        key: 'Customization',
        value: selectedOption.value,
      })
    }
    if (selectedOption.name === ProductOptionName.Engraving && selectedOption.value) {
      updatedCustomAttributes.push({
        key: 'Engraving',
        value: selectedOption.value,
      })
    }
  })
  return updatedCustomAttributes
}

export default useCartContextHelper

/* eslint-enable */
